<template>
<div>
    <pt-sub-title title="其他设置" ></pt-sub-title>
    <table :class="$style['message-table']" border="0" >
        <pt-form-list-item label="售后政策："    @widthItem="widthItem"  :widthMax="widthMax">
            <wt-selector :options="afterSalesPolicieList" v-model="goodsData.afterSalesPolicyId" :props="policieProp"></wt-selector>
            <el-button style="margin-left:10px;" type="primary" @click="addAfterSalesPolicie()">添加售后政策</el-button>
        </pt-form-list-item>
        <pt-form-list-item label="说明：" v-if="goodsData.afterSalesPolicy">
            <div :class="$style['privacy-policy-detail']" v-html="goodsData.afterSalesPolicy"></div>
            <!-- <wt-input  type="textarea" rows='4' :autosize="{ minRows: 5, maxRows:8}" class="afterSale-detail" v-model="goodsData.afterSalesPolicy"></wt-input> -->
        </pt-form-list-item>
        <pt-form-list-item label="运费规则："   :widthMax="widthMax">
            <wt-selector :options="carriagePoliciesList" v-model="goodsData.carriagePolicyId" :props="policieProp"></wt-selector>
            <el-button style="margin-left:10px;" type="primary" @click="addCarriagePolicy">添加运费规则</el-button>
        </pt-form-list-item>
        <pt-form-list-item label="内容：" v-if="goodsData.carriagePolicy">
            <div :class="$style['afterSale-detail']">
                {{goodsData.carriagePolicy}}
            </div>
            <!-- <wt-input  type="textarea" rows='4' :autosize="{ minRows: 5, maxRows:8}" class="afterSale-detail" v-model="goodsData.carriagePolicy"></wt-input> -->
        </pt-form-list-item>
        <pt-form-list-item label="隐私条款："   :widthMax="widthMax">
            <wt-selector :options="privacyPolicyList" v-model="goodsData.privacyPolicyId" :props="policieProp"></wt-selector>
            <el-button style="margin-left:10px;" type="primary" @click="addPrivacyPolicy">添加隐私条款</el-button>
        </pt-form-list-item>
        <pt-form-list-item label="内容：" v-if="privacyPolicyDetail">
            <div :class="$style['privacy-policy-detail']" v-html="privacyPolicyDetail"></div>
        </pt-form-list-item>
    </table>
    <el-dialog :visible="is_dialog" :title="dialog_title" @close="closeDialog()" :class="{'sales-dialog':is_after_sales,'privacy-policies-dialog':hasSimditorTextarea}">
        <new-after-sales-policie v-if="is_after_sales"  @closeDialog="closeDialog" :policyType="policyType" :policyContentMax="policyContentMax" fromPage="integral"></new-after-sales-policie>
    </el-dialog>
</div>
</template>
<script>
import emitter from '@/mixins/emitter'
import formMixins from 'mixins/form'
import newAfterSalesPolicie from 'cps/mall-manage/pt-goods-manage/pt-goods-form/new-after-sales-policie'
export default {
  mixins: [emitter, formMixins],
  props: {
    afterSalesPolicieList: Array,
    carriagePoliciesList: Array,
    privacyPolicyList: Array,
    widthMax: Number,
    value: Object,
    isEdit: Boolean
  },
  components: {
    newAfterSalesPolicie
  },
  computed: {

    // 是否是隐私条款
    isPrivacyPolicy () {
      return this.policyType === 'privacyPolicy'
    },
    // 是否售后政策
    isAfterSalesPolicy () {
      return this.policyType === 'afterSalesPolicy'
    },
    // dialog里面是否包含富文本
    hasSimditorTextarea () {
      return this.isPrivacyPolicy || this.isAfterSalesPolicy
    },
    is_dialog: {
      get: function () {
        return this.is_select_labels || this.is_select_meal || this.is_after_sales || this.is_taxation
      },
      set: function (val) {
        this.is_select_labels = val
        this.is_select_meal = val
        this.is_after_sales = val
        this.is_taxation = val
      }
    }
  },
  data () {
    return {
      policieProp: {
        label: 'name',
        value: 'id'
      },
      policyType: 'afterSalesPolicy',
      is_after_sales: false,
      privacyPolicyDetail: '',
      privacyPolicy: {},
      goodsData: {},
      dialog_title: null
    }
  },
  watch: {
    privacyPolicy: {
      handler: function (val) {
        this.$set(this.goodsData, 'privacyPolicyId', val.id)
        // this.$set(this.goodsData, 'carriagePolicy', val.content)
        this.privacyPolicyDetail = val.content
      },
      deep: true
    },
    goodsData: {
      handler: function (val) {
        this.$emit('change', val)
      },
      deep: true
    },
    'goodsData.afterSalesPolicyId' (val) {
      this.afterSalesPolicieList.forEach(item => {
        if (val === item.id) {
          this.goodsData.afterSalesPolicy = item.detail
        }
      })
    },

    'goodsData.carriagePolicyId' (val) {
      this.carriagePoliciesList.forEach(item => {
        if (val === item.id) {
          this.goodsData.carriagePolicy = item.content
        }
      })
    },
    'goodsData.privacyPolicyId' (val) {
      this.privacyPolicyList.forEach(item => {
        if (val === item.id) {
          this.privacyPolicyDetail = item.content
        }
      })
    },
    value: {
      handler: function (val) {
        if (this.isEdit) this.goodsData = val
      },
      deep: true
    }
  },
  methods: {
    widthItem (val) {
      this.$emit('widthItem', val)
    },
    // 添加运费规则
    addCarriagePolicy () {
      this.addAfterSalesPolicie('carriagePolicy')
    },
    // 添加隐私条款
    addPrivacyPolicy () {
      this.addAfterSalesPolicie('privacyPolicy')
    },

    addAfterSalesPolicie (type) {
      this.dialog_title = type === 'carriagePolicy' ? '新建运费模板' : (type === 'privacyPolicy' ? '新建隐私条款' : '新建售后政策')
      this.policyType = type || 'afterSalesPolicy'
      this.policyContentMax = type === 'carriagePolicy' ? 15 : null
      this.is_after_sales = true
    },

    closeDialog (data) {
      this.is_dialog = false
      if (data) {
        if (this.policyType === 'carriagePolicy') {
          this.dispatch('pt-integral-goods-form', 'getCarriagePolicies')
          //   this.$emit('getCarriagePolicies')
          this.carriagePolicy = data
        } else if (this.policyType === 'privacyPolicy') {
          this.dispatch('pt-integral-goods-form', 'getPrivacyPolicies')
          //   this.$emit('getPrivacyPolicies')
          this.privacyPolicy = data
        } else if (this.policyType === 'afterSalesPolicy') {
          this.dispatch('pt-integral-goods-form', 'afterSalesPolicies')
          //   this.$emit('afterSalesPolicies')
          this.afterSalesPolicy = data
        } else {
          console.error('未定义type')
        }
      }
    }
  }
}
</script>
<style module lang="less">
.privacy-policy-detail{
    height: 200PX;
    overflow-y: auto;
    border-radius: 5px;
    border: 1px solid #e4e7ed;
    padding: 10px 15px
}
.afterSale-detail{
    min-height:80PX;
    overflow-y: auto;
    border-radius: 5px;
    border: 1px solid #e4e7ed;
    padding: 10px 15px
}
.message-table{
    width: 100%;
    display: table!important;

    th,tr{
        display: table-row;
        width: 100%;
    }
     :global
    .wt-input{
        overflow: initial;
    }
    .el-input{
        width: auto!important
    }
    td{
        // padding-bottom: 10px;
        font-size: 14px;
        // color: @tipTextColor
    }
    textarea{
        max-width: 350px;
        font-family: "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", "Avenir", Helvetica, Arial!important
    }
}
</style>
